<div class="animated fadeIn">
  <div class="row sfapp-container">
    <div class="col-md-12">
      <div class="card">
        <div class="card-header">
          <div>
            <i><span class="material-symbols-outlined align-text-bottom" style="font-size: 1rem;">key</span></i>
            <span> 入退館QR</span>
          </div>
        </div>
        <div class="card-body">
          <div class="d-flex justify-content-center pb-3">
            <div class="d-flex flex-column" style="gap:0.5rem; width: 100%; max-width: 300px">
              <div class="d-flex justify-content-center">
                @if (showCode === 1) { <span>入館用コード</span> }
                @if (showCode === 0) { <span>退館用コード</span> }
              </div>
              <div style="position: relative; width: 100%; aspect-ratio: 1 / 1;">
                @if (showInitialLogo) {
                  <div style="position: absolute; inset: 0; opacity: 0.1; background: url('img/logo-symbol.png') center / contain no-repeat;" aria-hidden="true"></div>
                }
              <canvas
                id="qr-code-canvas"
                [style.visibility]="showInitialLogo ? 'hidden' : 'visible'"
                width="800"
                height="800"
                style="display: block; width: 100%; height: auto; max-width: 100%; aspect-ratio: 1 / 1;"
              ></canvas>
              </div>
              <div class="d-flex justify-content-center" [class.text-secondary]="qrExpiresIn <= 0" style="gap: 0.25rem">
                <span class="material-symbols-outlined align-self-center" style="font-size: 1rem">timer</span>
                <span> {{ formatTime(qrExpiresIn) }}</span>
              </div>
            </div>
          </div>
          <div class="d-flex justify-content-center" style="gap: 1rem">
            <button class="btn" [class.btn-outline-secondary]="disableUpdate" [class.btn-outline-info]="!disableUpdate"
                    (click)="updateQR(1)" [disabled]="disableUpdate">
              <span class="material-symbols-outlined align-text-bottom" style="font-size: 1rem">login</span>
              <span> {{ !isReady ? '準備中' : isUpdating ? '取得中' : disableUpdate ? formatTime(disableButtonIn) : '入館用' }}</span>
            </button>
            <button class="btn" [class.btn-outline-secondary]="disableUpdate" [class.btn-outline-info]="!disableUpdate"
                    (click)="updateQR(0)" [disabled]="disableUpdate">
              <span class="material-symbols-outlined align-text-bottom" style="font-size: 1rem">logout</span>
              <span> {{ !isReady ? '準備中' : isUpdating ? '取得中' : disableUpdate ? formatTime(disableButtonIn) : '退館用' }}</span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
